import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { UserService } from './user.service';
import { GlobalAlertService } from './global-alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ToggleElementsService } from './toggle-elements.service';

export enum Permission {
  create = 'CREATE',
  read = 'READ',
  update = 'UPDATE',
  delete = 'DELETE',
}

function hasPermission(permissions: string[], requiredPermissions: Permission[]): boolean {
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return false;
  }
  if (permissions.length === 0) {
    return false;
  }
  return requiredPermissions.every(permission => permissions.includes(permission));
}

const forbiddenPath = '/forbidden/index.html';
const errorTypeForbidden = 'unauthorized';

export const authGuard: CanActivateFn = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const userService = inject(UserService);
  const toggleElements = inject(ToggleElementsService);
  const messagingService = inject(GlobalAlertService);
  const router = inject(Router);
  const translateService = inject(TranslateService);

  const { requiredPermissions } = route.data;
  const permissions = await userService.getPermissions();

  if (permissions.length === 0 || !hasPermission(permissions, requiredPermissions)) {
    const homeUrl = await userService.getHomePageUrl();
    if (state.url.includes('edit') || state.url.includes('create')) {
      if (state.url.includes('edit')) {
        toggleElements.disable();
        messagingService.setError(
          translateService.instant('registration.notification.forbidden_edit_fields'),
          5000,
        );
        router.navigate([`/`]);
      } else if (state.url.includes('create')) {
        messagingService.setError(
          translateService.instant('registration.notification.forbidden_create'),
          5000,
        );
        document.location.href = document.location.origin + forbiddenPath + '?type=' + errorTypeForbidden;
      }
      return false;
    } else if (homeUrl) {
      document.location.href = homeUrl;
      return false;
    }
    document.location.href = document.location.origin + forbiddenPath + '?type=' + errorTypeForbidden;
    return false;
  } else {
    toggleElements.enable();
    return true;
  }
};
